export const validateRequired = (value: string) => {
  return (Array.isArray(value) && value.length > 0) || (!Array.isArray(value) && !!value) || "This field is required"
}
